export const exact3Base = "/exact3";
